import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/mother.webp";
import BlinkingText from "../../BlinkingText";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "كم باقي على عيد الأم 2026 العد التنازلي لعيد الأم 2026";
const DESCRIPTION =
  "كم باقي على عيد الأم، عيد الأم 2026، متى عيد الأم، كم باقي لعيد الأم، متى عيد الأم 2026، تاريخ عيد الأم 2026، موعد عيد الأم 2026، كم باقي على عيد الأم 2026، عيد الأم ٢٠٢٥، كم باقي على عيد الأم، كم باقي يوم على عيد الأم، عيد الأم 2026، كم باقي على عيد الأم 2026، موعد عيد الأم ٢٠٢٥، تاريخ عيد الأم، كم باقي على عيد الأم 2026، متى عيد الأم، كم يوم باقي لعيد الأم، عيد الأم،تاريخ عيد الأم، عيد الأم، عيد الأم، كم باقي على عيد الأم، عيد الأم، عيد الأم 2026، عيد الأم 1444 هجري، كم باقي على عيد الأم 2026، كم باقي لعيد الأم، كم باقي لعيد الأم 2026، موعد عيد الأم 2026، عيد الأم المبارك، عيد الأم، تاريخ عيد الأم 2026، كم باقي لعيد الأم، كم باقي على عيد الأم، كم باقي للعيد، عيد الأم 2026";
const KEYWORDS =
  "كم باقي على عيد الأم، عيد الأم 2026، متى عيد الأم، كم باقي لعيد الأم، متى عيد الأم 2026، تاريخ عيد الأم 2026، موعد عيد الأم 2026، كم باقي على عيد الأم 2026، عيد الأم ٢٠٢٥، كم باقي على عيد الأم، كم باقي يوم على عيد الأم، عيد الأم 2026، كم باقي على عيد الأم 2026، موعد عيد الأم ٢٠٢٥، تاريخ عيد الأم، كم باقي على عيد الأم 2026، متى عيد الأم، كم يوم باقي لعيد الأم، عيد الأم،تاريخ عيد الأم، عيد الأم، عيد الأم، كم باقي على عيد الأم، عيد الأم، عيد الأم 2026، عيد الأم 1444 هجري، كم باقي على عيد الأم 2026، كم باقي لعيد الأم، كم باقي لعيد الأم 2026، موعد عيد الأم 2026، عيد الأم المبارك، عيد الأم، تاريخ عيد الأم 2026، كم باقي لعيد الأم، كم باقي على عيد الأم، كم باقي للعيد، عيد الأم 2026";
const OG_URL = "https://do-calculate.com/articles-ar/motherday";
function MothersDay() {
  const calculateTimeLeft = (targetDate) => {
    const now = new Date();
    const difference = targetDate - now;
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };
  const initialDate = new Date("2026-03-21T00:00:00");
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(initialDate));
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);
  const mothersDayDates = [
    { name: "عيد الأم 2026", date: new Date("2026-03-21T00:00:00") },
    { name: "عيد الأم 2027", date: new Date("2027-03-21T00:00:00") },
    { name: "عيد الأم 2028", date: new Date("2028-03-21T00:00:00") },
    { name: "عيد الأم 2029", date: new Date("2029-03-21T00:00:00") },
    { name: "عيد الأم 2030", date: new Date("2030-03-21T00:00:00") },
  ];
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <FirstAds />
      </div>
      <h1 className="p-3 mb-2 bg-success text-white">
        كم باقي على عيد الأم 2026
      </h1>
      <div>
        <BlinkingText text="كم باقي على عيد الأم: من المتوقع أن يكون عيد الأم 2026 يوم الجمعة بتاريخ 21-03-2026 ميلادي." />
      </div>
      <div className="row">
        <div id="timer" style={{ width: "100%", fontSize: "40px" }}>
          <table
            style={{
              width: "100%",
              textAlign: "center",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
            }}
          >
            <thead>
              <tr>
                <th >يوم</th>
                <th >ساعة</th>
                <th >دقيقة</th>
                <th >ثوانٍ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td id="days">{timeLeft.days}</td>
                <td id="hours">{timeLeft.hours}</td>
                <td id="minutes">{timeLeft.minutes}</td>
                <td id="seconds">{timeLeft.seconds}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <SecondAds />
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div>
            <h2
              className="p-3 mb-2 bg-success text-white"
              style={{ color: "#333", fontSize: "36px", textAlign: "center" }}
            >
              مواعيد عيد الأم القادمة
            </h2>
            <table
              style={{
                fontSize: "24px",
                width: "100%",
                textAlign: "center",
                borderCollapse: "collapse",
                border: "2px solid #ccc",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th
                    style={{ padding: "16px", borderBottom: "2px solid #ccc" }}
                  >
                    موعد عيد الأم
                  </th>
                  <th
                    style={{ padding: "16px", borderBottom: "2px solid #ccc" }}
                  >
                    التاريخ
                  </th>
                  <th
                    style={{ padding: "16px", borderBottom: "2px solid #ccc" }}
                  >
                    باقي
                  </th>
                </tr>
              </thead>
              <tbody>
                {mothersDayDates.map((date, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                    }}
                  >
                    <td style={{ padding: "12px" }}>{date.name}</td>
                    <td style={{ padding: "12px" }}>
                      {date.date.toLocaleDateString("en-GB")}
                    </td>
                    <td style={{ padding: "12px" }}>
                      {calculateTimeLeft(date.date).days} يوم
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col" style={{ paddingTop: "28px" }}>
          <MainCalculatorsList></MainCalculatorsList>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <h3 className="p-3 mb-2 bg-success text-white">
            كم باقي على عيد الأم 2026
          </h3>
          <p>
            في هذا المقال، نقدم لكم العد التنازلي المفصل لعيد الأم، لتكونوا على
            اطلاع دائم بكم يوم باقٍ على وصول هذا اليوم المميز. الكثير منا
            يتسائلون كم باقي على عيد الأم، لهذا نقدم لكم في هذا المقال العد
            التنازلي لعيد الأم لتتمكنوا من معرفة كم باقي على عيد الأم، كم باقي
            على عيد الأم 2026، كم يوم باقي على عيد الأم شاهدوا العد التنازلي
            لعيد الأم في الأعلى.
          </p>
          <p>
            وفقا لموقع{" "}
            <a href="/calculator/ar/gregorian_to_hijri/">تحويل التاريخ</a> يصادف
            عيد الأم 2026 يوم الجمعة 21-03-2026 ميلادي، يمكنكم مشاهدة العد
            التنازلي لعيد الأم 2026 في هذا المقال.
          </p>
          <p>
            تجدون هنا العد التنازلي لعيد الأم، حيث يمكنكم معرفة كم باقي يوم على
            عيد الأم.
          </p>
          <hr />
          <RelatedLinks />
          <hr />
          <h3 className="p-3 mb-2 bg-success text-white">
            احسب كم باقي لعيد الأم
          </h3>
          <p>
            من خلال برنامج حساب العد التنازلي لعيد الأم يمكنكم معرفة كم باقي
            لعيد الأم بالتقويم الميلادي والهجري، كما يمكنكم معرفة كم باقي على
            عيد الأم كم يوم، وكم تبقى لعيد الأم، كم تبقى لعيد الأم بالأيام، ومتى
            عيد الأم العد التنازلي، كم باقي على عيد الأم، كم تبقى على عيد الأم،
            كم باقي على عيد الأم، كم باقي على عيد الأم 2026، وموعد عيد الأم لهذه
            السنة، كل عام وانتم بخير وأعاده الله علينا وعليكم باليمن والبركات.
          </p>
          <h3 className="p-3 mb-2 bg-success text-white">عيد الأم</h3>
          <p>
            عيد الأم هو احتفال سنوي لتكريم الأمهات والاحتفاء بهن. هو يوم يعبر
            فيه الأفراد عن شكرهم وتقديرهم لأمهاتهم من خلال الهدايا والكلمات
            الطيبة والأفعال المميزة. يتم الاحتفال بعيد الأم في مختلف أنحاء
            العالم في تواريخ مختلفة، ولكن الهدف هو نفسه: تكريم الأمهات على كل ما
            يقدمنه لأسرهن وللمجتمع.
          </p>
          <div>
            <br />
            <img
              src={imageUrl}
              alt="كم باقي على عيد الأم"
              width="800"
              height="450"
              style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
              loading="lazy"
            />
            <br />
          </div>
          <h3 className="p-3 mb-2 bg-success text-white">
            من آداب الاحتفال بعيد الأم
          </h3>
          <p>
            ـ التعبير عن التقدير والامتنان للأمهات من خلال الكلمات الطيبة
            والهدايا المميزة.
            <br />
            ـ قضاء وقت مميز مع الأم والاحتفال معها بطرق مختلفة كتناول وجبة معاً
            أو الخروج في نزهة.
            <br />
            ـ تذكير الأمهات بأهميتهن ودورهن الكبير في حياة الأسرة والمجتمع.
            <br />
          </p>
        </div>
        <br />
      </div>
    </div>
  );
}
export default MothersDay;
